module.exports = __webpack_public_path__ + "static/img-runway-screen-8db639ba194b4446eda94948cc65a77b.png";